import React from 'react';
import { trackAddToCart } from './MetaPixel';
export function FinalCtaSection() {
  return <section className="py-16 md:py-24 bg-brand-dark text-white text-center" data-id="element-44">
      <div className="max-w-4xl mx-auto px-5 md:px-8" data-id="element-45">
        <h2 className="text-3xl md:text-5xl font-serif font-bold mb-6 leading-tight" data-id="element-46">
          Está Na Hora de Sentir Seu Corpo Leve de Novo
        </h2>
        <p className="text-lg md:text-xl text-white/80 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-47">
          Você não precisa aceitar o inchaço como parte normal da idade. Você
          não precisa continuar testando dietas que deixam você cansada. Você
          não precisa esperar segunda-feira.
        </p>

        <div className="max-w-md mx-auto" data-id="element-48">
          <a href="https://pay.hotmart.com/B106409754W" onClick={trackAddToCart} className="block w-full bg-brand-cream hover:bg-white text-brand-dark text-center font-bold px-6 py-5 rounded-xl text-lg md:text-xl transition-all duration-300 shadow-lg transform hover:-translate-y-1 mb-4" data-id="element-49">
            QUERO COMEÇAR O DESINCHA40+ AGORA
          </a>
          <p className="text-sm text-white/60" data-id="element-50">
            Compra segura via Hotmart. Acesso imediato no seu e-mail.
          </p>
        </div>
      </div>
    </section>;
}